import { useParams } from "react-router-dom";
import DealThread from "@/components/deal/DealThread";

/** Full-page version of the deal thread (deep links, emails, "open as a page"). */
export default function DealDetailPage() {
  const { id = "" } = useParams();
  return (
    <div className="h-[calc(100dvh-3rem)] md:h-screen">
      <DealThread dealId={id} />
    </div>
  );
}
